import React from "react";
import Layout from "../../components/layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewUser() {
  const location = useLocation();
  const data = location.state.data;
  const navigate = useNavigate();
  
  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View User</h2>

            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>
          </div>
          <div className="mt-10">
            <div className="my-6">
              <img
                src={
                  data.imageUrl
                    ? `${process.env.REACT_APP_MEDIA_BASE_URL}/${data.imageUrl}`
                    : `https://api.dicebear.com/7.x/initials/svg?seed=${data.firstName + data.lastName
                    }
`
                }
                className="h-[100px] w-[100px] rounded-full border-2"
                alt=""
              />
            </div>
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">First Name</h6>
                <p className="mt-1">{data.firstName}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Last Name</h6>
                <p className="mt-1">{data.lastName}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Email</h6>
                <p className="mt-1">{data.email}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Phone</h6>
                <p className="mt-1">{data.phone}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Email Verification</h6>
                <p className="mt-1">{data.isEmailVerified ? "Yes" : "No"}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Phone Verification</h6>
                <p className="mt-1">{data.isPhoneVerified ? "Yes" : "No"}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Wallet Amount</h6>
                <p className="mt-1">{data.wallet}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(data.createdAt)}</p>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </Layout>
    </div>
  );
}
